module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "comp-reword-form",
    attrs: {
      "visible": _vm.visible,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('div', {
    staticClass: "dialog-title flex flex-between"
  }, [_c('div', {
    staticClass: "lef flex"
  }, [_c('span', {
    staticClass: "reword-post"
  }, [_vm._v("岗位悬赏-" + _vm._s(_vm.postTitle))]), _vm._v(" "), (_vm.type === 'on') ? _c('span', {
    staticClass: "status s-on"
  }, [_vm._v("进行中")]) : _vm._e(), _vm._v(" "), (_vm.type === 'end') ? _c('span', {
    staticClass: "status s-end"
  }, [_vm._v("已终止")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close close-btn",
    on: {
      "click": _vm.close
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info-box flex"
  }, [_c('div', {
    staticClass: "reword-no"
  }, [_vm._v("悬赏任务编号：" + _vm._s(_vm.detailInfo.code))]), _vm._v(" "), (_vm.type === 'on') ? _c('div', {
    staticClass: "reword-no"
  }, [_vm._v("悬赏任务截止时间: " + _vm._s(_vm.detailInfo.planEndAt))]) : _vm._e()]), _vm._v(" "), (_vm.type === 'on') ? [_c('div', {
    staticClass: "warn-btns flex flex-between"
  }, [_c('span', {
    staticClass: "warn"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("如需更改佣金请终止悬赏重新发布")]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleAllHistory
    }
  }, [_vm._v("全部岗位悬赏转发任务历史")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-warn",
    on: {
      "click": function($event) {
        _vm.showConfirmDialog = true
      }
    }
  }, [_vm._v("终止悬赏")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block-box flex"
  }, _vm._l((_vm.blockListOne), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "block-item flex"
    }, [_c('img', {
      staticClass: "icon-img",
      attrs: {
        "src": _vm.iconInfo[item.key]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.detailInfo[item.field] || 0))])])])
  }))] : _vm._e(), _vm._v(" "), (_vm.type === 'end') ? [_c('div', {
    staticClass: "block-btns flex align-start flex-between"
  }, [_c('div', {
    staticClass: "block-box flex"
  }, _vm._l((_vm.blockListTwo), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "block-item flex"
    }, [_c('img', {
      staticClass: "icon-img",
      attrs: {
        "src": _vm.iconInfo[item.key]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.detailInfo[item.field] || 0))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleAllHistory
    }
  }, [_vm._v("全部岗位悬赏转发任务历史")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-reword",
    on: {
      "click": _vm.toConfig
    }
  }, [_vm._v("重新发布悬赏")])], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-box"
  }, [_c('div', {
    staticClass: "table-tit flex"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("岗位悬赏明细")]), _vm._v(" "), _c('span', {
    staticClass: "total"
  }, [_vm._v(_vm._s(("共" + _vm.tableTotal + "条")))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "height": "400px",
      "overflow-y": "auto"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "toUserName",
      "label": "浏览用户"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fromUserName",
      "label": "转发用户"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "悬赏任务编号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rewardAt",
      "label": "浏览时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rewardAmount",
      "label": "转发佣金(元)"
    }
  })], 1), _vm._v(" "), (_vm.tableTotal > 0) ? _c('el-pagination', {
    staticClass: "flex flex-end",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30],
      "page-size": _vm.pageSize,
      "layout": "sizes, prev, pager, next",
      "total": _vm.tableTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showConfirmDialog) ? _c('div', {
    staticClass: "confirm-box"
  }, [_c('div', {
    staticClass: "confirm-dialog"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("终止悬赏")]), _vm._v(" "), _c('span', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showConfirmDialog = false
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "confirm-content"
  }, [_vm._v("\n        确认要终止该岗位的悬赏转发吗？终止后将停止发放对分享用户的奖励\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer flex flex-center"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showConfirmDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.handleConfirmEnd
    }
  }, [_vm._v("确认终止")])], 1)])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2512a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reword/Form.vue
// module id = 856
// module chunks = 1